module.exports = "precision highp float;\n#define GLSLIFY 1\n\nattribute vec2 uv;\nattribute vec3 position;\nvarying vec2 vUv;\nuniform mat4 projectionMatrix;\nuniform mat4 viewMatrix;\nuniform mat4 modelMatrix;\n\nvoid main(void) {\n  vUv = uv;\n\tgl_Position = projectionMatrix * viewMatrix * modelMatrix * vec4( position, 1.0 );\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/scene/Shader/base.vert
// module id = zbJZ
// module chunks = 1